import React from 'react';
import ButtonCTA from './ButtonCTA';
import TrustpilotWidget from './TrustpilotWidget';

interface CTASectionProps {
  title: string;
  description: string;
  className?: string;
}

const CTASection: React.FC<CTASectionProps> = ({ title, description, className = '' }) => {
  return (
    <section className={`bg-emerald-700 text-white p-8 sm:p-12 rounded-lg text-center ${className}`}>
      <div className="max-w-2xl mx-auto">
        <h2 className="text-2xl sm:text-3xl font-semibold mb-4 sm:mb-6">{title}</h2>
        <p className="text-lg sm:text-xl mb-6 sm:mb-8 leading-relaxed">
          {description}
        </p>
        <div className="max-w-[430px] mx-auto">
          <ButtonCTA />
        </div>
        <div className="mt-6 flex justify-center">
          <TrustpilotWidget />
        </div>
      </div>
    </section>
  );
};

export default CTASection; 